<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in storehouseIds"
        v-if="item.key !== -1"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form
                  ref="refForm"
                  :inline="true"
                  :model="form"
                  class="demo-form-inline"
                >
                  <el-form-item>
                    <el-select
                      v-model="search_type"
                      placeholder="QC号"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in search_options"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-left: -15px; width: 165px">
                    <el-input
                      v-model="search_value"
                      placeholder="请输入搜索内容"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_cp"
                      placeholder="是否次品"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in is_cp"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_repair"
                      placeholder="是否修复"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in is_repair"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.p_catid"
                      placeholder="一级分类"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in conditionData.cp_cat"
                        v-if="item.pid == 0"
                        :key="item.cp_catid"
                        :label="item.name"
                        :value="item.cp_catid"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.cp_catid"
                      placeholder="二级分类"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in conditionData.cp_cat"
                        v-if="item.pid == form.p_catid"
                        :key="item.cp_catid"
                        :label="item.name"
                        :value="item.cp_catid"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_supply_dbid"
                      placeholder="是否爆版打标"
                    >
                      <el-option
                        v-for="item in is_supply_dbid_option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.order_id"
                      placeholder="订单号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_minor_defect"
                      placeholder="是否微次"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in is_minor_defect_option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.quality_rule"
                      placeholder="质检规则"
                    >
                      <el-option
                        v-for="item in qualityRuleOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="质检时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      :default-time="['06:00:00', '06:00:00']"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 370px"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_no"
                      placeholder="货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      style="background-color: #e1e1e1"
                      @click="resetCondition"
                      >重置</el-button
                    >
                  </el-form-item>

                  <div v-if="is_show_search_option">
                    <el-form-item>
                      <el-select
                        v-model="form.market_id"
                        placeholder="市场"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.market"
                          :key="item.market_id"
                          :label="item.market_name"
                          :value="item.market_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="width: 150px">
                      <el-input
                        v-model="form.supply_name"
                        placeholder="档口"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.pg_id"
                        placeholder="买手组"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.picker_group"
                          :key="item.pg_id"
                          :label="item.pg_name"
                          :value="item.pg_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="width: 150px">
                      <el-select
                        v-model="form.cat_id"
                        placeholder="服装类型"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.cat"
                          :key="item.cat_id"
                          :label="item.cat_name"
                          :value="item.cat_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.stock_source"
                        placeholder="选择入库来源"
                      >
                        <el-option value="" label="全部"></el-option>
                        <el-option
                          v-for="item in conditionData.stockSource"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.high_quality"
                        placeholder="是否高级质检"
                      >
                        <el-option
                          v-for="item in generalOption"
                          :key="item.key"
                          :label="item.name"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>

          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
          >
            <!--<el-table-column align="right" type="selection" width="55" ></el-table-column>-->

            <el-table-column
              prop="dbid"
              label="打标id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              width="140"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wcg_order_info_price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="cat_name_1"
              label="一级分类"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cat_name_2"
              label="二级分类"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cat_name_3"
              label="三级分类"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="left"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              width="140"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            ></el-table-column>

            <el-table-column
              prop="stockin_time"
              label="入库时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_in_record_stock_source"
              label="入库来源"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dber"
              label="点货人员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sdbr_text"
              label="是否爆版打标"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_shipping_stock_out"
              label="是否发货出库"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quality_type"
              label="质检类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quality_rule"
              label="质检规则"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="order_id"
              label="订单号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="desk_no"
              label="工作台"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="qc"
              label="质检人员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="质检时间"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="high_quality_text"
              label="是否高级质检"
              width="100"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="quality_checking_is_cp"
              label="是否次品"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="p_name"
              label="次品一级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cp_name"
              label="次品二级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_minor_defect_text"
              label="是否微次"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quality_checking_is_repair"
              label="是否修复"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="xf_qc"
              label="修复人员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="xf_time"
              label="修复时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="remark" label="质检视频" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="showVideo(scope.row)">
                  查看
                </el-button>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="seRemark(scope.row)"
                ></el-button>
                <span>{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper"
            :total="resData.count"
            :page-size="form.pagesize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>

        <!-- <el-dialog title="备注" :visible.sync="RemarkVisible">
                    <el-form :model="form" >
                        <el-form-item >
                            <el-input type="textarea" v-model="form.remark" placeholder="备注" :value="" @input=""></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="RemarkVisible = false">取 消</el-button>
                        <el-button type="primary" @click="doRemark">确 定</el-button>
                    </div>
                </el-dialog> -->
      </el-col>
    </el-row>
    <el-dialog
      :before-close="handleVideoClose"
      :visible.sync="showQualityVideoList"
      title="质检视频列表"
      width="800px"
    >
      <el-button @click="handleCopy(showVideoPath)"> 打开文件夹 </el-button>
      <el-table :data="qualityVideoList">
        <el-table-column label="文件" width="400">
          <template slot-scope="scope">
            <div
              class="video-wrap"
              @click="handleCopy(`${showVideoPath}\\${scope.row.video_key}`)"
            >
              <i class="el-icon-video-camera-solid" />
              <span class="video-file-name">{{ scope.row.video_key }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="起始时间">
          <template slot-scope="scope">
            <div
              class="video-wrap"
              @click="handleCopy(`${showVideoPath}\\${scope.row.video_key}`)"
            >
              <span>{{ scope.row.start_point }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleVideoClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      curPage: 1,
      filterFold: false,
      conditionData: {},
      resData: {
        setting: "未配置数据",
      },
      search_options: [
        { key: "pc_checker", name: "PC质检人员" },
        { key: "qc", name: "QC人员" },
        { key: "dbid", name: "打标id" },
        { key: "sku", name: "SKU编号" },
        { key: "xf_qc", name: "修复人员" },
        // {"key" : "goods_no", "name" : "商品货号"},
      ],
      search_value: "",
      form: {
        pagesize: 10,
        create_time: this.defaultDate(),
        order_id: "",
        goods_no: "",
        quality_rule: "",
        is_minor_defect: "", //	是否微次{1:是;2:否}
      },
      is_minor_defect_option: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      origins: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      is_supply_dbid_option: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      qualityRuleOption: [
        {
          value: 1,
          label: "默认质检规则配置",
        },
        {
          value: 2,
          label: "质检绿色通道配置",
        },
        {
          value: 3,
          label: "高级质检商品配置",
        },
        {
          value: 4,
          label: "二次重配商品配置",
        },
        {
          value: 5,
          label: "高价值商品配置",
        },
        {
          value: 6,
          label: "高排单/区域订单商品配置",
        },
        {
          value: 7,
          label: "新客订单质检配置",
        },
        {
          value: 8,
          label: "高净值用户质检配置",
        },
      ],
      is_cp: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      is_repair: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      is_revision: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      generalOption: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      show_log_time: 0,
      loading: false,
      url: "/erp/QualityChecking/getList",
      origin: 1,
      is_show_search_option: true,
      search_type: "qc",
      tableLoading: false,
      // RemarkVisible:false
      showQualityVideoList: false,
      qualityVideoList: [],
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
  },

  // created() {
  //   this.fetchData();
  // },
  methods: {
    seRemark(row) {
      this.qc_id = row.qc_id;
      // this.form.remark=row.remark;
      // this.RemarkVisible=true;
      this.$prompt("", "备注", {
        inputType: "textarea",
        inputValue: row.remark,
      })
        .then((val) => {
          // console.log('then', val);
          this.$set(this.form, "remark", val.value);
          this.doRemark();
        })
        .catch(() => {});
    },
    doRemark() {
      this.$http
        .post("/erp/QualityChecking/setRemark", {
          qc_id: this.qc_id,
          remark: this.form.remark,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.dbid = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
              this.RemarkVisible = false;
            }
          }
        });
    },
    tableRowClassName({ row }) {
      if (row.is_stock == 1) {
        return "stock-row";
      }
      return "";
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(1, 6);
    },

    output() {
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },

    search() {
      // this.$refs.refForm.resetFields();
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      this.fetchData(true);
    },
    selectOrigin(key) {
      this.form.origin = key;
      this.origin = key;
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, origin: key })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            this.resData = res.data.data;
          } else {
            this.resData = res.data.data;
          }
        });
    },

    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code === 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      Object.keys(this.search_options).forEach((key) => {
        this.$set(this.form, this.search_options[key].key, "");
      });
      if (this.search_value !== "") {
        this.$set(this.form, this.search_type, this.search_value);
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.resData = {};
        } else {
          this.resData = res.data.data;
          this.origin = this.resData.origin;
          if (undefined != this.resData.condition) {
            this.conditionData = this.resData.condition;
          }
        }
      });
    },

    resetCondition() {
      this.form = {
        create_time: this.defaultDate(),
      };
      this.search_value = "";
    },
    showVideo(row) {
      this.$http
        .post("/erp/QualityChecking/getVideo", {
          qc_id: row.qc_id,
        })
        .then((res) => {
          const { data, code } = res.data;
          console.log("res", res);
          if (code === 200) {
            this.showQualityVideoList = true;
            this.showVideoPath = data.path;
            this.qualityVideoList = data.list;
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    handleVideoClose() {
      this.showQualityVideoList = false;
      this.showVideoPath = "";
      this.qualityVideoList = [];
    },
    handleCopy(text) {
      this.$copyText(text).then(() => {
        this.$message.success("复制成功！请在其他浏览器或者文件夹上打开");
      });
    },
  },
};
</script>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>
<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.video-wrap {
  cursor: pointer;
}

.video-file-name {
  margin-left: 8px;
}

.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 60%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video-modal__text {
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/quality/QualityList.vue